import { Component, OnInit, Input, NgZone, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { RestApiService } from "../../shared/rest-api.service";
import { Title } from "@angular/platform-browser";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReCaptchaService } from 'angular-recaptcha3';
import { WhiteSpaceValidator } from './whitespace.validator';

declare let $: any;

@Component({
	selector: 'app-tenant',
	templateUrl: './tenant.component.html',
	styleUrls: ['./tenant.component.css']
})
export class TenantComponent implements OnInit {
	
	registerForm: FormGroup;
	submitted               = false;
	public isDisabled       = false;
	public isDisabledVerify = false;
	pkID : any = 0;
	public timeLeft: number;
	interval : any;
	public packages: any;

	constructor(
		public restApi: RestApiService, 
		public router: Router,
		public route: ActivatedRoute,
		public ngZone: NgZone,
		private titleService:Title,
		private formBuilder: FormBuilder,
		private elementRef: ElementRef,
		private recaptchaService: ReCaptchaService
	) {
		this.titleService.setTitle("Registration");
	}
	
	@Input() tenantDetails = { id : this.pkID, tenantPackageID: this.route.snapshot.params.id, tenantName: '', tenantEmail: '', orgName: '', designation: '', address: '', contactNumber : '', gstinNo: '', token: ''  }

	login() {
		 this.recaptchaService.execute({action: 'login'}).then(token => {
		   // Backend verification method
		   //this.sendTokenToBackend(token);
		   //console.log('token :', token);
		 });
	}

	ngOnInit(): void {
		this.getPackages();
		this.loadScript('https://www.google.com/recaptcha/api.js?render=6LdHqsQdAAAAANKkSvJmHs-bmnfoJHdgjqQbC-hE');
		this.registerForm = this.formBuilder.group({
			tenantPackageID: [''],
			tenantName: ['', [ Validators.required, Validators.pattern('[a-zA-Z\. ]*$'), Validators.maxLength(50), WhiteSpaceValidator.noWhiteSpace ]],
			// tenantEmail: ['', [Validators.required, Validators.email]],
			tenantEmail: ['', [ Validators.required, Validators.pattern('^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$'), Validators.maxLength(150) ] ],
			//contactNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(14)]],
			contactNumber: ['', [ Validators.required, Validators.pattern("[0-9]{10}") ]],
			orgName: ['', [ Validators.required, Validators.pattern('[a-zA-Z0-9&. ]*$'), Validators.maxLength(100), WhiteSpaceValidator.noWhiteSpace ]],
			designation: ['', [ Validators.required, Validators.pattern('[a-zA-Z&. ]*$'), Validators.maxLength(100), WhiteSpaceValidator.noWhiteSpace ]],
			gstinNo: ['', [ Validators.pattern('[a-zA-Z0-9]*$'), Validators.maxLength(15)]],
			address: ['', [ Validators.required, Validators.pattern('[a-zA-Z0-9\s  _\\\./-/#/,/(/)-]{3,100}$'), Validators.maxLength(100), WhiteSpaceValidator.noWhiteSpace ]],
			token: [''] // we will validate captcha input value at the backend side
        });
	}

	public loadScript(url: string) {
		const body = <HTMLDivElement> document.body;
		const script = document.createElement('script');
		script.innerHTML = '';
		script.src = url;
		script.async = false;
		script.defer = true;
		body.appendChild(script);
	}
	
	// convenience getter for easy access to form fields
	get f() { return this.registerForm.controls; }
	
	addTenant() {
		this.restApi.createTenant(this.tenantDetails).subscribe((data: {}) => {
			//this.router.navigate(['/employees-list'])
			window.alert('Your registration has been successfully completed');
			this.router.navigate(["/"]);
			/* this.ngZone.run(() => {
				this.router.navigateByUrl('/tenant-registration');
			}); */
		})
	}
	
	onSubmit() {
		//console.log(this.registerForm);
		this.submitted = true;
		if (this.registerForm.invalid) {
			return;
		} else {
			this.isDisabled = true;
			this.recaptchaService.execute({action: 'Registration'}).then(token => {
				this.restApi.sendMail(this.tenantDetails).subscribe((data: {}) => {
					console.log(this.tenantDetails);
					if(data[0].result == 'invalidToken') {
						window.alert('Invalid request. Please try again!');
						this.isDisabled = false;
						window.location.reload();
					} else if(data[0].result == 'fieldMissing') {
						window.alert('something went wrong. Please try again!');
					} else if(data[0].result == 'failed') {
						window.alert('something went wrong. Please try again!');
					} else if(data[0].result == 'success') {
						window.alert('Your registration has been successfully completed');
						this.isDisabled = false;
						this.router.navigate(["/"]);
					} else {
						window.location.reload();
					}
				});
			});
		}
    }
	
	onEmailVerify() {
		this.timeLeft = 20;
		this.isDisabledVerify = true;
		if(this.registerForm.controls['tenantEmail'].status == 'VALID'){
			// console.log(this.isDisabledVerify);
			this.restApi.sendEmailOTP(this.tenantDetails).subscribe((data: any ) => {
				this.tenantDetails.id = data[0].pkid;
				// console.log('OTP Sent Successfully');
				alert('OTP sent to the entered Email ID.');
				this.onDisplayTimer();
			});
			
		}else{
			this.isDisabledVerify = false;
		}
		// console.log(this.registerForm.controls['tenantEmail'].value)
		return;
	}

	getPackages(): void {
		this.restApi.getPackages().subscribe(
			packages => {
				this.packages = packages;
				console.log(packages);
			},
			error => {
			  console.log(error);
			}
		);
	}
	
	onDisplayTimer() {
		let jsScript = document.createElement("script");
		jsScript.type = "text/javascript";
		jsScript.async = true;
		jsScript.innerHTML  = '$("#timerDiv").show();$("#emailOTPID").show();';
		document.body.appendChild(jsScript);
		this.startTimer();
	}
	
	startTimer() {
		this.interval = setInterval(() => {
			if(this.timeLeft > 0) {
				this.timeLeft--;
			} else {
				clearInterval(this.interval);
				this.isDisabledVerify = false;
				let jsScript = document.createElement("script");
				jsScript.type = "text/javascript";
				jsScript.async = true;
				jsScript.innerHTML  = '$("#timerDiv").hide();';
				document.body.appendChild(jsScript);
			}
		},1000)
	}
	
	verifyOTP() {

	}

	ngAfterViewInit(): void {
		setTimeout(function () {
			$.getScript('assets/scripts/jquery-3.3.1.js', function(){});
			let jsScript = document.createElement("script");
			jsScript.type = "text/javascript";
			jsScript.async = true;
			jsScript.innerHTML  = "$(document).ready(function () { $('.grecaptcha-badge').show(); });";
			document.body.appendChild(jsScript); 
		},400);
	}
	
	onCaptchaExpired(event) {
		console.log('token2 : ',event);
	}

	onCaptchaResponse(event) {
		console.log(event);
		this.registerForm.controls['token'].setValue(event);
		this.registerForm.controls['token'].patchValue(event);
	}
	
	
}
